import * as React from 'react';

const TiktokIcon: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_43_8)">
        <path
          d="M118.769 0H9.2315C4.13275 0 0 4.13275 0 9.2315V118.769C0 123.867 4.13275 128 9.2315 128H118.769C123.867 128 128 123.867 128 118.769V9.2315C128 4.13275 123.867 0 118.769 0ZM96.0618 48.9897V57.643C91.9813 57.6445 88.0165 56.845 84.2775 55.2673C81.8732 54.2523 79.6333 52.9442 77.5845 51.364L77.646 77.9995C77.6203 83.9972 75.2475 89.6325 70.953 93.877C67.458 97.332 63.0293 99.5292 58.2293 100.24C57.1013 100.407 55.9535 100.493 54.7928 100.493C49.6545 100.493 44.776 98.8282 40.7855 95.7572C40.0345 95.179 39.3165 94.5522 38.6325 93.877C33.9782 89.277 31.5783 83.042 31.9823 76.4833C32.2908 71.4905 34.2895 66.729 37.6217 62.997C42.0305 58.0585 48.1983 55.3172 54.7928 55.3172C55.9535 55.3172 57.1013 55.4042 58.2293 55.5715V58.771V67.6712C57.16 67.3185 56.0177 67.1245 54.8285 67.1245C48.8035 67.1245 43.9292 72.04 44.0192 78.0693C44.0762 81.927 46.1838 85.2992 49.2918 87.158C50.7523 88.0317 52.4328 88.5727 54.226 88.6712C55.631 88.7482 56.98 88.5528 58.2293 88.1403C62.5338 86.7183 65.639 82.675 65.639 77.9065L65.6533 60.07V27.507H77.5703C77.5818 28.6877 77.7015 29.84 77.9242 30.9562C78.8237 35.475 81.3707 39.3955 84.9157 42.0682C88.0067 44.3997 91.8557 45.7817 96.0277 45.7817C96.0305 45.7817 96.0647 45.7817 96.062 45.779L96.0618 48.9897Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_43_8">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { TiktokIcon };
